import { useTranslation } from 'react-i18next';

function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="py-8">
      <h1 className="text-4xl font-bold text-center">{t('errors.notFound')}</h1>
      <p className="mt-4 text-lg text-center">{t('errors.pageNotFound')}</p>
    </div>
  );
}

export default NotFound;
